import styled, { css } from "styled-components";
import Photo from "shared/components/data-display/media/Photo";
import Text from "shared/components/data-display/mui/Text";

export const Container = styled.div`
    margin-top: 2rem;
`;

export const Body = styled.div`
    text-align: center;
    overflow-y: auto;
    overflow-x: hidden;
    padding: ${globalThis.config.sizes.sidebar.gutter};
    height: ${(props) =>
        props.canViewAllocations
            ? "calc(100vh - 48px - 2rem - 117px - 2.5vh)"
            : "calc(100vh - 48px - 2rem - 66px - 2.5vh)"};
    ::-webkit-scrollbar-thumb {
        background-color: #fff;
    }
    :hover {
        ::-webkit-scrollbar-thumb {
            background-color: #dde1e5;
        }
    }
`;

export const EmployeePicture = styled(Photo)`
    width: 12rem;
    height: 12rem;
    border-radius: 10rem;
    margin: 0 auto;
    object-fit: cover;
    display: flex;
    margin-bottom: 1.5rem;
`;

export const Title = styled.div`
    margin: 0;
    display: inline-flex;
    width: -webkit-fill-available;
`;

export const Tag = styled.div`
    width: 4.75rem;
    margin: 0 0 0.5em;
    display: flex;
    background-color: ${globalThis.config.colors.gray6};
    border-radius: 0.1rem;
    text-align: left;
    padding: 0.2rem;
    p {
        margin: 0 auto;
    }
`;

export const ButtonLink = styled.a`
    p {
        text-decoration: none;
    }
    &:hover {
        text-decoration: none;
    }
    button {
        width: 100%;
        white-space: nowrap;
        margin-bottom: 0.5rem;
    }
    margin-bottom: 0.5rem;
`;

export const TextLink = styled.a`
    color: ${globalThis.config.colors.black};
    text-decoration: underline;
    display: block;
    &:hover {
        color: ${globalThis.config.colors.black};
    }
`;

export const Footer = styled.div`
    padding: ${globalThis.config.sizes.sidebar.gutter};
    padding-top: 40px;
    text-align: center;
    > * {
        margin-bottom: 0.5rem;
    }
    position: absolute;
    width: 100%;
    bottom: 2.5vh;
`;

export const MoreMenuContainer = styled.div`
    padding: 0.5rem 0 0 0.5rem;
`;

export const Section = styled.div`
    margin: 1em 0 0 0;
    > p {
        width: 100%;
        text-align: initial;
    }
`;

export const GroupSection = styled.div`
    padding-bottom: 1.5rem;
    padding-top: 0.5rem;
    border-bottom: 1px solid;
    border-bottom-color: ${globalThis.config.colors.gray6};

    ${(props) =>
        props.borderBottomNone &&
        css`
            border-bottom: none;
        `}
`;

export const SkillSearchContainer = styled.div``;

export const LabelText = styled(Text)`
    width: 100%;
    text-align: initial;
`;

export const TitleText = styled(Text)`
    margin: 0.5rem 0 0 0;
`;

